import { RoofSlapT } from './RoofSlapT';
import { MonitorColorRegionT } from './monitor-object/MonitorRegionT';
import { MonitorColorSphereT } from './monitor-object/MonitorSphereT';

export const ModelsInArchiBase = {
    'RoofSlapT': RoofSlapT,
    "MonitorColorRegionT": MonitorColorRegionT,
    "MonitorColorSphereT": MonitorColorSphereT
};
